<template>
	<div class="strategio-bgmain-view fill-height">
    <strategio-app-bar></strategio-app-bar>
    <v-speed-dial
      id="options-button"
      fixed
      v-model="fab"
      bottom
      right
      direction="top"
      transition="scale-transition"
      elevation-6
      v-intro="'Desde aquí podrá marcar este reporte como favorito, ver la lista de reportes disponibles o regresar a la página de reportes'"
    >
      <v-btn
        slot="activator"
        fab
        hover
        x-large
        color=""
        @click="goBack"
        class="strategio-bgbutton-primary"
      >
        <v-icon color="white">arrow_back</v-icon>
      </v-btn>
    </v-speed-dial>
    <v-main class="fill-height">
      <iframe class="strategio-iframe" :src="url" frameborder="0" style="height: 100%; width: 100%;"></iframe>
    </v-main>
  </div>
</template>
<script>
import StrategioAppBar from '../../../components/header-bar/strategio-app-bar.vue'
export default {
  components: {
    StrategioAppBar
  },
  data () {
    return {
      url: 'https://onedrive.live.com/embed?resid=C20195D3EE2F228F%2145766&authkey=!AEpusgXQNvdlQ1s&em=2&AllowTyping=True&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True'
    }
  },
  methods: {
    goBack () {
      this.$router.back()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/routes/autoservicios/bonus/show-bonus-report.vue